import { Box, Grid, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BetArea from '../../../../../../components/common/betArea';
import { VideoPlayerContext } from '../../../../../../contexts/VideoContext';
import { AndarBaharTotalBet } from '../../../../../../models/games/andarBahar';
import { BetType } from '../../../../../../models/games/andarBahar/BetType';
import { RootState } from '../../../../../../store/store';
import { getTotalBets } from '../../../../../totalBet/slice';
import { amountOverBetLimit, isOppositeBetting } from '../utils';
import betAreaJson from './noCommBetArea.json';

const { betType } = betAreaJson;
export const AndarBaharNoCommBetArea = () => {
    const { t } = useTranslation();
    const { hostId } = useContext(VideoPlayerContext);
    const { TotalBet } = useSelector((state: RootState) =>
        getTotalBets(state, hostId)
    );

    const [andarBetRate, setAndarBetRate] = useState<number>(0);
    const [baharBetRate, setBaharBetRate] = useState<number>(0);

    useEffect(() => {
        if (TotalBet) {
            const BetAmount = TotalBet as AndarBaharTotalBet;
            const andarAmount = BetAmount.Andar ? BetAmount.Andar.Amount : 0;
            const baharAmount = BetAmount.Bahar ? BetAmount.Bahar.Amount : 0;
            const totalAmount = andarAmount + baharAmount;

            setAndarBetRate(Math.round((andarAmount / totalAmount) * 100) || 0);
            setBaharBetRate(Math.round((baharAmount / totalAmount) * 100) || 0);
        }
    }, [TotalBet]);
    return (
        <>
            <Grid
                item
                container
                flexWrap={'nowrap'}
                justifyContent={'space-between'}
                sx={{ padding: '4px 5px 0px 5px' }}
            >
                <Box sx={{ position: 'relative' }}>
                    <Typography
                        sx={{
                            position: 'absolute',
                            borderRadius: '0px 0px 0px 5px',
                            background: '#000000',
                            opacity: '0.8',
                            height: '25%',
                            left: '3px',
                            bottom: '3px',
                            right: '3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                        }}
                    >
                        {t('andar_bahar.nc_andar_payout')}
                    </Typography>
                    <BetArea
                        style={betType[BetType.ABBNCAndarWin].style}
                        confirmPanelStyle={
                            betType[BetType.ABBNCAndarWin].confirmPanelStyle
                        }
                        imageName={betType[BetType.ABBNCAndarWin].image}
                        betType={BetType.ABBNCAndarWin}
                        perColor={'92,126,255'}
                        amountOverBetLimit={amountOverBetLimit}
                        isOppositeBetting={isOppositeBetting}
                        isFlash={true}
                        // defaultLang={betType[BetType.ABBNCAndarWin].defaultLang}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            right: '1px',
                            top: '1px',
                            width: '25%',
                            height: 'fit-content',
                            borderRadius: '0 0 0 10px',
                            backgroundColor: 'rgba(0, 0, 0, 0.35)',
                            alignItems: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '13px',
                                textAlign: 'right',
                                paddingTop: '4px',
                                paddingRight: '12px',
                                paddingBottom: '4px',
                            }}
                        >{`${andarBetRate}%`}</Typography>
                    </Box>
                </Box>
                <Box sx={{ position: 'relative' }}>
                    <BetArea
                        style={betType[BetType.ABBNCBaharWin].style}
                        confirmPanelStyle={
                            betType[BetType.ABBNCBaharWin].confirmPanelStyle
                        }
                        imageName={betType[BetType.ABBNCBaharWin].image}
                        betType={BetType.ABBNCBaharWin}
                        perColor={'94,193,58'}
                        amountOverBetLimit={amountOverBetLimit}
                        isOppositeBetting={isOppositeBetting}
                        isFlash={true}
                        // defaultLang={betType[BetType.ABBNCBaharWin].defaultLang}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            right: '1px',
                            top: '1px',
                            width: '25%',
                            height: 'fit-content',
                            borderRadius: '0 0 0 10px',
                            backgroundColor: 'rgba(0, 0, 0, 0.35)',
                            alignItems: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '13px',
                                textAlign: 'right',
                                paddingTop: '4px',
                                paddingRight: '12px',
                                paddingBottom: '4px',
                            }}
                        >{`${baharBetRate}%`}</Typography>
                    </Box>
                </Box>
            </Grid>
            <Grid
                item
                container
                flexWrap={'nowrap'}
                justifyContent={'space-between'}
                sx={{
                    padding: '4px 5px 0px 5px',
                }}
            >
                <BetArea
                    style={betType[BetType.ABBNC1To5].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC1To5].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC1To5].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC1To5].image}
                    betType={BetType.ABBNC1To5}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC6To10].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC6To10].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC6To10].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC6To10].image}
                    betType={BetType.ABBNC6To10}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC11To15].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC11To15].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC11To15].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC11To15].image}
                    betType={BetType.ABBNC11To15}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC16To20].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC16To20].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC16To20].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC16To20].image}
                    betType={BetType.ABBNC16To20}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC21To25].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC21To25].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC21To25].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC21To25].image}
                    betType={BetType.ABBNC21To25}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
            </Grid>
            <Grid
                item
                container
                flexWrap={'nowrap'}
                justifyContent={'space-between'}
                sx={{
                    padding: '4px 5px 0px 5px',
                }}
            >
                <BetArea
                    style={betType[BetType.ABBNC26To30].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC26To30].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC26To30].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC26To30].image}
                    betType={BetType.ABBNC26To30}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC31To35].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC31To35].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC31To35].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC31To35].image}
                    betType={BetType.ABBNC31To35}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC36To40].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC36To40].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC36To40].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC36To40].image}
                    betType={BetType.ABBNC36To40}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC41To45].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC41To45].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC41To45].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC41To45].image}
                    betType={BetType.ABBNC41To45}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
                <BetArea
                    style={betType[BetType.ABBNC46To49].style}
                    confirmPanelStyle={
                        betType[BetType.ABBNC46To49].confirmPanelStyle
                    }
                    confirmedChipContainerStyle={
                        betType[BetType.ABBNC46To49].confirmedChipContainerStyle
                    }
                    imageName={betType[BetType.ABBNC46To49].image}
                    betType={BetType.ABBNC46To49}
                    amountOverBetLimit={amountOverBetLimit}
                    isOppositeBetting={isOppositeBetting}
                    isFlash={true}
                    isMultiLang={false}
                />
            </Grid>
        </>
    );
};
